import { Point } from '@rta/rta-blueprint-library';

export type GetVectorAngleParams = {
	from: Point,
	to: Point
}
export const getVectorAngle = ({ from, to }: GetVectorAngleParams): number => {
	const x = to.x - from.x;
	const y = to.y - from.y;

	return Math.atan2(x, y) * 180 / Math.PI;
};
